import { LoadingOutlined } from '@ant-design/icons';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const LoadingToRedirect = () => {
  const [count, setCount] = useState(3);
  const navigate = useNavigate();

  useEffect(() => {
    const interval = setInterval(() => {
      setCount((currentCount) => --currentCount);
    }, 1000);

    count === 0 && navigate('/login');
    return () => clearInterval(interval);
  }, [count, navigate]);

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        height: '100vh',
      }}
    >
      <LoadingOutlined style={{fontSize:'48px', fontWeight:'600'}} />
      <p style={{ fontSize: '28px', fontWeight: '500', marginTop: '20px' }}>
        Kembali ke halaman login dalam {count} detik
      </p>
      <p
        style={{
          fontSize: '16px',
          fontWeight: '400',
          color: '#b4b4b4',
          marginTop: '-10px',
        }}
      >
        Silahkan Login Terlebih dahulu
      </p>
    </div>
  );
};

export default LoadingToRedirect;
